import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import React from 'react'
import { useFonts, Manrope_600SemiBold } from '@expo-google-fonts/manrope';

type Props = {
    messageText: string,
    actionText: string,
    actionTextPress?: () => void
}

export default function HaveAccount(props: Props) {

    const [fontsLoaded] = useFonts({
        Manrope_600SemiBold
    });

    if (!fontsLoaded) {
        return null
    }

    return (
        <View style={styles.row}>
            <Text style={styles.dontHave}>{props.messageText}?</Text>
            <TouchableOpacity onPress={props.actionTextPress}>
                <Text style={styles.actionText}>{props.actionText}</Text>
            </TouchableOpacity>
        </View>
    )
}

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        justifyContent: "center",
        gap: 4

    }
    ,
    dontHave: {
        fontSize: 16,
        fontFamily: "Manrope_600SemiBold",
        color: "#0D0E0E"
    }
    ,
    actionText: {
        fontSize: 16,
        fontFamily: "Manrope_600SemiBold",
        color: "#160062",
        textDecorationLine: "underline"
    }
})